import reducer from "./reducer";
export { default as GroupClassification } from "./components/index";
export { default as groupClassificationReducerName } from "./constants";
export default reducer;
